import React from "react";
import { LoadingAnimationHOC } from "@tinqin/tinqin-ui-components/src/loading-animation";
import internalStateService from "../../app/InternalStateService";

const loadingProps = () => {
    let defaultData = {
        fadeinTime: 0,
        fadeoutTime: 500,
        contentRenderWaitingTime: 0
    };
    if (internalStateService.getComponentsDefaultConfig()["widgetLoading"]) {
        return Object.assign(
            defaultData,
            internalStateService.getComponentsDefaultConfig()["widgetLoading"]
        );
    } else return defaultData;
};

//Base loading animation (no fadein/fadeout) for a Widget
//using LoadingAnimationHOC
export const LoadingAnimation = (props) => {

        let Preloader = internalStateService.getComponent("preloader");
        let customContent;
        if (props.preloaderType) {
            customContent = internalStateService.getComponent("preloaderTypes")[
                props.preloaderType
            ];
        }
        return (
            <Preloader customContent={customContent} {...props}>
                {props.children}
            </Preloader>
        );
}

export default LoadingAnimationHOC(LoadingAnimation, loadingProps);
